// Deutsche Zahlen- / Währungs- / Flächen-Formatierung
const deNumber = new Intl.NumberFormat("de-DE", {
  maximumFractionDigits: 0,
});
const deNumber2 = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const deEur = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});
const deEur2 = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const fmtInt = (n) => (n == null || isNaN(n) ? "—" : deNumber.format(n));
export const fmtDec = (n) => (n == null || isNaN(n) ? "—" : deNumber2.format(n));
export const fmtEur = (n) => (n == null || isNaN(n) ? "—" : deEur.format(n));
export const fmtEur2 = (n) => (n == null || isNaN(n) ? "—" : deEur2.format(n));
export const fmtQm = (n) => (n == null || isNaN(n) ? "—" : `${deNumber.format(n)} m²`);
export const fmtPct = (n) => (n == null || isNaN(n) ? "—" : `${deNumber.format(n)} %`);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};
